import type React from "react";

interface CardProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}

export function Card({ children, delay = 0, className = "" }: CardProps): React.JSX.Element {
  return (
    <div
      className={`bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-sm ${className}`}
      style={{ animation: `pmFade 600ms ease-out ${delay}ms both` }}
    >
      {children}
    </div>
  );
}

export function CardLabel({ children }: { children: React.ReactNode }): React.JSX.Element {
  return (
    <p className="text-white/40 text-[11px] font-body uppercase tracking-widest mb-4">
      {children}
    </p>
  );
}
